export const XS_BREAKPOINT = 576;
export const SM_BREAKPOINT = 768;
export const MD_BREAKPOINT = 992;
export const LG_BREAKPOINT = 1200;
export const XL_BREAKPOINT = 1400;
